import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import useCountUp from '../useCountUp';
import { Container, Header, Labels, Tiles } from './styles';

function CountUpBattery({ data, styles }) {
  const fontFamilyTimer = FONT_FAMILY[styles?.timer?.font || 'notoSans'];
  const fontFamilyTitle = FONT_FAMILY[styles?.title?.font || 'notoSans'];

  const [hours, minutes, seconds] = useCountUp({
    status: data.status,
    time: data.time,
  });

  return (
    <>
      <FontFamilyHeader family={fontFamilyTimer} />
      <FontFamilyHeader family={fontFamilyTitle} />
      <Container>
        <Header
          style={{
            color: styles?.title?.color,
            fontFamily: fontFamilyTitle?.family,
            fontSize: styles?.title?.size,
            letterSpacing: styles?.title?.letterSpacing,
            lineHeight: styles?.title?.size
              ? `${styles?.title?.size}px`
              : undefined,
          }}
        >
          {data.title}
        </Header>
        <Tiles>
          <span
            style={{
              color: styles?.timer?.color,
              fontFamily: fontFamilyTimer?.family,
              fontSize: styles?.timer?.size,
              letterSpacing: styles?.timer?.letterSpacing,
            }}
          >
            {hours}
          </span>
          <span
            style={{
              color: styles?.timer?.color,
              fontFamily: fontFamilyTimer?.family,
              fontSize: styles?.timer?.size,
              letterSpacing: styles?.timer?.letterSpacing,
            }}
          >
            {minutes}
          </span>
          <span
            style={{
              color: styles?.timer?.color,
              fontFamily: fontFamilyTimer?.family,
              fontSize: styles?.timer?.size,
              letterSpacing: styles?.timer?.letterSpacing,
            }}
          >
            {seconds}
          </span>
        </Tiles>
        <Labels>
          <li
            style={{
              color: styles?.title?.color,
              fontFamily: fontFamilyTitle?.family,
              fontSize: styles?.title?.size,
              letterSpacing: styles?.title?.letterSpacing,
              lineHeight: styles?.title?.size
                ? `${styles?.title?.size}px`
                : undefined,
            }}
          >
            {i18n.t('common.hours')}
          </li>
          <li
            style={{
              color: styles?.title?.color,
              fontFamily: fontFamilyTitle?.family,
              fontSize: styles?.title?.size,
              letterSpacing: styles?.title?.letterSpacing,
              lineHeight: styles?.title?.size
                ? `${styles?.title?.size}px`
                : undefined,
            }}
          >
            {i18n.t('common.minutes')}
          </li>
          <li
            style={{
              color: styles?.title?.color,
              fontFamily: fontFamilyTitle?.family,
              fontSize: styles?.title?.size,
              letterSpacing: styles?.title?.letterSpacing,
              lineHeight: styles?.title?.size
                ? `${styles?.title?.size}px`
                : undefined,
            }}
          >
            {i18n.t('common.seconds')}
          </li>
        </Labels>
      </Container>
    </>
  );
}

CountUpBattery.propTypes = {
  data: PropTypes.shape({
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
  styles: PropTypes.shape({
    timer: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    title: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

CountUpBattery.defaultProps = {
  data: {
    status: 'paused',
    time: [],
    title: 'Total Time',
  },
  styles: {
    timer: {
      color: '#111111',
      font: 'notoSans',
      letterSpacing: 1,
      size: 60,
    },
    title: {
      color: '#ffff00',
      font: 'notoSans',
      letterSpacing: 1,
      size: 18,
    },
  },
};

export default CountUpBattery;
